import { Modal } from 'react-bootstrap'
import React, { useState, useEffect } from 'react'

export const PONumberSearchModal = ({ isVisible, onClose, awcidSearchWithPo }) => {
    const [searchTerm, setSearchTerm] = useState('')
    const handleInputChange = (event) => {
        setSearchTerm(event.target.value)
    }
    const handleClose = () => {
        setSearchTerm('')
        onClose()
    }
    return (
        <Modal
            show={isVisible}
            dialogClassName='lock-warning-signature-modal-dialog '
            backdropClassName='veil'
            animation={false}
            centered
            autoFocus={false}
            onHide={onClose}
            onKeyPress={(e) => {
                var key = e.which || e.keyCode || 0
                key === 13 && e.preventDefault()
            }}
        >
            <Modal.Header closeButton>
                <Modal.Title style={{ display: 'inline-block' }}>
                    If you dont have a serial number or tag number we can try to look for a AWCID
                    with a PO number
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div
                    style={{
                        display: 'flex',
                        gap: '10px',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >
                    <input
                        type='text'
                        placeholder='Enter PO number'
                        onChange={handleInputChange}
                        value={searchTerm}
                        style={{ padding: '10px', flex: 1 }}
                    />
                    <button
                        className='btn btn-success'
                        onClick={() => {
                            awcidSearchWithPo(searchTerm)
                            handleClose()
                        }}
                        style={{ padding: '10px 20px', cursor: 'pointer' }}
                    >
                        Search
                    </button>
                </div>
            </Modal.Body>
        </Modal>
    )
}
